import React, { useState, useEffect } from "react";

import config from "config";
import useChat from "hooks/use-chat";
import AgentsDropdown from "../agents-dropdown";

const TicketSummary = () => {
  const { ticket, ticketUserImage, userName, userRoleName, userClinic } =
    useChat();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!modalOpen) return;
    const handleKey = (e) => e.key === "Escape" && setModalOpen(false);
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [modalOpen]);

  const imageSrc = ticketUserImage?.attributes?.original;
  const aiMessageRoomId = ticket?.attributes?.ai_message_room_id;

  return (
    <div className="ticketSection">
      <div>
        <h3>Agent</h3>
        <AgentsDropdown />
        <h3>User</h3>
        <div className="user-summary" style={{ maxWidth: "270px" }}>
          {imageSrc && (
            <img
              src={imageSrc}
              alt="User avatar"
              className="ticket-user-avatar"
              onClick={() => setModalOpen(true)}
            />
          )}
          <div className="flexColumn">
            <span>{userName}</span>
            <span className="subtext" style={{ marginTop: "2px" }}>
              {userRoleName}
              {userClinic?.attributes?.clinic_name &&
                ` • ${userClinic.attributes.clinic_name}`}
            </span>
          </div>
        </div>
        {aiMessageRoomId && (
          <>
            <h3>AI conversation</h3>
            <a
              className="phone-call-modal-task-link"
              href={`${config.admin}/message-rooms/${aiMessageRoomId}/messages`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in admin
            </a>
          </>
        )}
      </div>

      {modalOpen && (
        <div
          className="image-modal-overlay"
          onClick={() => setModalOpen(false)}
        >
          <img
            src={imageSrc}
            alt="User avatar"
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default TicketSummary;
